<div class="modal-header">
  <h4 class="modal-title">Görüntüle</h4>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <form [formGroup]="form">
    <label>Pdf Şablonu Seç</label>
    <div class="form-group">
      <ng-select [items]="pdfs" bindLabel="pdfTitle" bindValue="id" formControlName="pdfId"></ng-select>
      <div *ngIf="form.get('pdfId').touched && form.get('pdfId').invalid" class="text-danger">
        <small *ngIf="form.get('pdfId').errors?.required">PDF şablonu seçimi zorunludur.</small>
      </div>
    </div>
    <div class="form-group">
      <label for="whatsappMessage">Yollamak İstediğiniz Mesajı Giriniz</label>
      <input type="text" class="form-control" formControlName="whatsappMessage">
    </div>
  </form>
</div>

<div class="modal-footer d-flex">
  <button type="button" class="btn btn-danger btn-sm" (click)="closeModal()">
    <span data-feather="x"></span>
  </button>
  <button type="button" class="btn btn-info btn-sm" [disabled]="form.invalid" (click)="submitForm(false)">
    <span data-feather="eye"></span>Görüntüle
  </button>
  <button type="button" class="btn btn-success btn-sm" [disabled]="form.invalid" (click)="submitForm(true)">
    <span data-feather="download"></span>İndir
  </button>
  <button type="button" class="btn btn-success btn-sm" [disabled]="form.invalid" (click)="sendPdfToWhatsapp()">
    <span data-feather="message-circle"></span>Paylaş
  </button>
</div>